import e from "./index13.js";
import { openBlock as r, createElementBlock as s, normalizeClass as n } from "vue";
import t from "../../../../_virtual/index.js";
const a = ["id"];
function c(o, i, m, l, p, d) {
  return r(), s("div", {
    id: o.uniqueId,
    class: n(o.className)
  }, null, 10, a);
}
const $ = /* @__PURE__ */ t(e, [["render", c]]);
export {
  $ as default
};
//# sourceMappingURL=index12.js.map
